export const LAYOUT = {
    GET_BREADCRUMB: "layout/GET_BREADCRUMB",
    SET_BREADCRUMB: "layout/SET_BREADCRUMB",
    GET_HEADER_TRANPARENT: "layout/GET_HEADER_TRANPARENT", //headerTranparent
    SET_HEADER_TRANPARENT: "layout/SET_HEADER_TRANPARENT",
    SET_LANGUAGE_ID:"layout/SET_LANGUAGE_ID"
};
